
import React from 'react';
import LogoImage from "assets/img/logo-suzano.png";
import {Image} from "react-bootstrap";

import {loginRequest} from "auth/authAzure";
import {useMsal} from "@azure/msal-react";

const AuthForm = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch(e => {
            console.error(e);
        });
    }
    return (
        <section>
            <div className="login-page">
                <div className="login-box">
                    <div className="card">
                        <div className="card-header text-center py-3">
                            <Image src={LogoImage} className="ml-3" width={150}/>
                        </div>
                        <div className="card-body login-card-body">
                            <div className="d-grid gap-2 col-12 mx-auto">
                                <button type="button" className="btn btn-primary" onClick={ () => handleLogin() }>Acessar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default AuthForm;

/*

import React from 'react';
import LogoImage from "assets/img/logo-suzano.png";
import {Image} from "react-bootstrap";

import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';

import {useUser} from "store/providers/app";
import {loginRequest} from "../../../auth/authAzure";
import {useMsal} from "@azure/msal-react";

const AuthForm = () => {
    const {login, loginAzure} = useUser()

    const { instance } = useMsal();

    const loginUser = (email, password) =>  {
        login(email, password)
    }

    const handleLogin = () => {
        instance.loginPopup(loginRequest).then(r => {
            console.log('response', r);

        }).catch(err => {
            console.log(err);
        });
    }

    const SignupSchema = Yup.object().shape({
        email: Yup.string().email('Email inválido').required('Preencha o campo e-mail'),
        password: Yup.string().required('Preencha o campo senha')
    });

    return (
        <section>
            <div className="login-page">
                <div className="login-box">
                    <div className="card">
                        <div className="card-header text-center py-3">
                            <Image src={LogoImage} className="ml-3" width={150}/>
                        </div>
                        <div className="card-body login-card-body">

                            <Formik
                                initialValues={{
                                    email: '',
                                    password: '',
                                }}
                                validationSchema={SignupSchema}
                                onSubmit={values => {
                                    loginUser(values.email, values.password);
                                }}
                            >
                                {({ errors, touched }) => (
                                    <Form>

                                        <div className="form-group">
                                            <label className="form-label">E-mail</label>
                                            <Field name="email" type="email" className="form-control" />
                                            {errors.email && touched.email ? <div className="text-sm text-danger">{errors.email}</div> : null}
                                        </div>

                                        <div className="form-group">
                                            <label className="form-label">Senha</label>
                                            <Field name="password" type="password" className="form-control"/>
                                            {errors.password && touched.password ? (
                                                <div className="text-sm text-danger">{errors.password}</div>
                                            ) : null}
                                        </div>
                                        <div className="d-grid gap-2 mt-3 col-12 mx-auto">
                                            <button type="submit" className="btn btn-success">Entrar</button>
                                            <button type="button" className="btn btn-primary" onClick={ () => handleLogin() }>Azure</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};

export default AuthForm;
*/
